module.exports = __webpack_public_path__ + "cfe4bf3d8707868bfa874f79838a29b4.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/map/0.png
// module id = 1345
// module chunks = 0